"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = function _default() {
  var defaultState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    return state;
  };
};
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/thunderball-client/lib/reducers/createGenericReducer.js
// module id = 3073
// module chunks = 25